import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { PontoVolumePorTipo } from '../solicitacoesDashboard.utils';

interface VolumePorTipoChartProps {
  dados: PontoVolumePorTipo[];
}

/** Barras horizontais (`layout="vertical"` no recharts, nome invertido de propósito) —
 * rótulos de tipo são longos ("Mudança de Projeto", "Troca de Equipamento"), não cabem
 * bem no eixo X de um gráfico vertical comum sem cortar ou girar o texto. */
export default function VolumePorTipoChart({ dados }: VolumePorTipoChartProps) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <h3 className="mb-4 font-montserrat text-base font-semibold text-gray-900">Volume por Tipo de Solicitação</h3>
      <ResponsiveContainer width="100%" height={Math.max(220, dados.length * 36)}>
        <BarChart data={dados} layout="vertical" margin={{ left: 24 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis type="number" allowDecimals={false} style={{ fontSize: '12px', fontFamily: 'Montserrat' }} stroke="#6b7280" />
          <YAxis
            type="category"
            dataKey="label"
            width={160}
            style={{ fontSize: '12px', fontFamily: 'Montserrat' }}
            stroke="#6b7280"
          />
          <Tooltip
            contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontFamily: 'Montserrat' }}
            formatter={(valor: number) => [valor, 'Solicitações']}
          />
          <Bar dataKey="quantidade" fill="#6366F1" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
